import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { FormikProvider, useFormik } from "formik";
import { useState } from "react";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import InputFormik from "../../../../common/components/form/InputFormik";
import "./ModalCreateCostCenter.scss";
import { CostCenterApi, createCostCenter } from "../../../../common/services/purchaseCostCenter.api";

type Props = {
  onClose?: () => void
}

export default function ModalCreateCostCenter(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [loading, setLoading] = useState(false);
  const handleCloseModal = () => { props.onClose && props.onClose() };

  const initialValues = {
    description: "",
    categoriesId: [],
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (data: CostCenterApi) => {
      setLoading(true);
      const result = await createCostCenter(data);
      if (!result.ok && result.message) {
        notifyError(result.message);
      }
      setLoading(false);
      notifySuccess("Criado Centro de custo com sucesso.");
      handleCloseModal();
    }
  });

  return (
    <Modal
      className='relative text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">{'Novo Centro de Custo'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormikProvider value={formik}>
          <InputFormik label="Nome do Centro de Custo" name="description"></InputFormik>
        </FormikProvider>
        <div className="containerButtonCategory">
          <ButtonWithLoader isLoading={loading} onClick={formik.handleSubmit}>Cadastrar</ButtonWithLoader>
        </div>
      </Modal.Body>
    </Modal>
  );
}